import { Checkbox } from "@fluentui/react-components";
import { Checkmark12Filled } from "@fluentui/react-icons";
import classnames from "owa-classnames";
import type React from "react";
import { checkboxInput, checkboxIndicator, defaultCheckbox, subtleCheckbox, selectedCheckbox, checkedCheckbox, hoverBorder, subtleHoverBorder, hoverCheckmark, } from "./MailListCheckbox.scss";

export interface MailListCheckboxProps {
    className?: string;
    checked: boolean | "mixed";
    isSelected?: boolean;
    isSubtle?: boolean;
}

/**
 * Visual-only Fluent v9 checkbox for message list rows and item parts. The caller's container is
 * the accessible checkbox and owns click handling, so this checkbox is hidden from assistive
 * technology, ignores pointer events, and has no onChange.
 */
export default function MailListCheckbox(props: MailListCheckboxProps): React.JSX.Element {
    const { className, checked, isSelected, isSubtle } = props;
    
    let stateClass;
    if (checked) {
        stateClass = checkedCheckbox;
    }
    else if (isSelected) {
        stateClass = selectedCheckbox;
    }
    else if (isSubtle) {
        stateClass = subtleCheckbox;
    }
    else {
        stateClass = defaultCheckbox;
    }
    
    return (<Checkbox className={classnames(className, isSubtle ? subtleHoverBorder : hoverBorder, stateClass)} checked={checked} root={checkboxRootSlot} input={checkboxInputSlot} indicator={checked ? checkedIndicatorSlot : uncheckedIndicatorSlot}/>);
}

const checkboxRootSlot = { "aria-hidden": true };
const checkboxInputSlot = { tabIndex: -1, className: checkboxInput };
// Unchecked boxes carry a hidden copy of Fluent's default checkmark that shows on hover.
const uncheckedIndicatorSlot = {
    className: checkboxIndicator,
    children: <Checkmark12Filled className={hoverCheckmark}/>,
};
const checkedIndicatorSlot = { className: checkboxIndicator };
